import { useState, useEffect } from 'react';

const QUOTE_LINE_1 = "\u201cI wish there was a way to know you\u2019re in the good days,";
const QUOTE_LINE_2 = "before you left them.\u201d";

// Swap to '/ui/good-days-logo.png' once the real logo file is in place
const LOGO_SRC = '/ui/good-days-logo.png';

// Logo settles ~1.3s → 500ms gap → lines animate → 800ms gap → button
// Line 1: 1.8s delay, 1.2s duration → settled ~3.0s
// Line 2: 3.0s delay, 1.2s duration → settled ~4.2s
// Button: 4.2s + 0.8s gap + 0.1s buffer = 5100ms
const BUTTON_DELAY_MS = 5100;

export const IntroScreen = ({ onContinue }) => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowButton(true), BUTTON_DELAY_MS);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="intro-screen" data-testid="intro-screen">
      {/* CRT scanline overlay */}
      <div className="intro-scanlines" aria-hidden="true" />
      {/* CRT edge vignette */}
      <div className="intro-vignette" aria-hidden="true" />

      <div className="intro-content">

        {/* 1. Logo */}
        <div className="intro-logo">
          <img
            src={LOGO_SRC}
            alt="Good Old Days"
            className="intro-logo-img"
            onError={e => { e.currentTarget.style.display = 'none'; }}
          />
        </div>

        {/* 2. Quote */}
        <blockquote className="intro-quote">
          <span className="intro-line intro-line-1">{QUOTE_LINE_1}</span>
          <span className="intro-line intro-line-2">{QUOTE_LINE_2}</span>
        </blockquote>

        {/* 3. Button */}
        {showButton && (
          <button
            className="intro-launch-btn"
            onClick={onContinue}
            data-testid="intro-launch-btn"
          >
            Welcome to the Good Days
          </button>
        )}

      </div>
    </div>
  );
};

export default IntroScreen;
